import { render } from "./RatingLabels.vue?vue&type=template&id=3bb27f20&scoped=true"
import script from "./RatingLabels.vue?vue&type=script&lang=js"
export * from "./RatingLabels.vue?vue&type=script&lang=js"

import "./RatingLabels.vue?vue&type=style&index=0&id=3bb27f20&lang=scss&scoped=true"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bb27f20"]])

export default __exports__